import CSSModules from 'react-css-modules';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AnchorLink, Button, RawHtml, Icon } from 'platfi-ui-components';

import withModal from 'HOC/withModal';
import CompletedStars from 'assets/svgs/completed-stars.svg';
import CapitaliseRelax from 'assets/svgs/capitalise-relax.svg';

import ModalFixedHeader from 'components/modal/ModalFixedHeader';

import styles from './PreRequestModal.scss';

@CSSModules(styles)
class PreRequestModal extends PureComponent {
  static propTypes = {
    modalState: PropTypes.instanceOf(Map),
  };

  handleClick = (onAccept, closeModal) => {
    onAccept();
    closeModal('preRequestModal');
  };

  renderLeftSide = ({ companyName, logo, logoUrl }, supportInstantOffer) => (
    <div styleName="o-modal-pre-request__left">
      <span className="u-inline-block o-modal__icon">
        <CompletedStars className="a-svg-completed-stars" />
        <h2 className="o-modal__title-lg u-color-primary">{"You're ready"}</h2>
      </span>

      <div styleName="o-modal-pre-request__left__text">
        {supportInstantOffer
          ? 'Submit your profile to get a instant offer from '
          : 'Submit your profile to '}
        <span styleName="o-modal-pre-request__left__text__name">{companyName}</span>
      </div>

      <div styleName="o-modal-pre-request__left__brand">
        <img
          alt={companyName}
          src={logo || logoUrl}
          styleName="o-modal-pre-request__left__brand__image"
        />
        <span styleName="o-modal-pre-request__left__brand__icon">
          <Icon
            styleName="o-modal-pre-request__left__brand__media"
            className="a-svg-small"
            icon="check"
          />
        </span>
      </div>
    </div>
  );

  renderRightSide = (
    onAccept,
    closeModal,
    { preRequestDetails, companyName },
    supportInstantOffer,
  ) => (
    <div styleName="o-modal-pre-request__right">
      <div styleName="o-modal-pre-request__right__title">What are the next steps?</div>

      <div styleName="o-modal-pre-request__right__card">
        <div styleName="o-modal-pre-request__right__card__icon">
          <Icon icon={supportInstantOffer ? 'offer' : 'application'} className="a-svg-xxxlarge" />
        </div>

        <div styleName="o-modal-pre-request__right__card__content">
          <div styleName="o-modal-pre-request__right__card__title">
            {supportInstantOffer ? 'Before you get an offer' : 'Before you submit'}
          </div>

          <div styleName="o-modal-pre-request__right__card__description">
            {`When you continue we'll send your information to ${companyName} who will store and process it.`}
          </div>

          <div styleName="o-modal-pre-request__right__card__description">
            <RawHtml>{preRequestDetails}</RawHtml>
          </div>
        </div>
      </div>

      <div styleName="o-modal-pre-request__right__card">
        <div styleName="o-modal-pre-request__right__card__icon">
          <CapitaliseRelax className="a-svg a-svg-xxxxlarge" />
        </div>

        <div styleName="o-modal-pre-request__right__card__content">
          <div styleName="o-modal-pre-request__right__card__title">Finish your profile</div>

          <div styleName="o-modal-pre-request__right__card__description">
            {"You're profiles not quite complete - finish it now to submit to the final lenders."}
          </div>
        </div>
      </div>
      <div styleName="o-modal-pre-request__right__buttons">
        <Button
          onClick={() => this.handleClick(onAccept, closeModal)}
          primary
          styleName="o-modal-pre-request__right__button"
        >
          {supportInstantOffer
            ? `Get an offer from ${companyName}`
            : `Send Application to ${companyName}`}
        </Button>

        <AnchorLink
          styleName="o-modal-pre-request__right__buttons__label"
          label="Do not submit now"
          secondary
          onClick={() => closeModal('preRequestModal')}
        />
      </div>
    </div>
  );

  render() {
    const { modalState } = this.props;
    const onAccept = modalState?.getIn(['props', 'onAccept']);
    const closeModal = modalState?.getIn(['props', 'closeModal']);
    const lenderInformation = modalState?.getIn(['props', 'lenderInformation']);
    const match = modalState?.getIn(['props', 'match']);
    const supportInstantOffer = match.canUseInstantOffer;

    return (
      <>
        <div className="o-col-block">
          <div className="o-fluid-col-sml-6">
            {this.renderLeftSide(lenderInformation, supportInstantOffer)}
          </div>
          <div styleName="o-modal-pre-request__square" />
          <div className="o-fluid-col-sml-6">
            {this.renderRightSide(onAccept, closeModal, lenderInformation, supportInstantOffer)}
          </div>
        </div>

        <ModalFixedHeader />
      </>
    );
  }
}

export default withModal({
  contentOnTop: false,
  secondary: false,
  modalId: 'preRequestModal',
  unmountOnClose: true,
})(PreRequestModal);
